import { images } from '../constants';

const services = [
{
    id: 1,
    image: images.service1,
    title: 'Selected Coffee Beans',
    content: 'Premium-grade coffee beans sourced from the finest farms, roasted to perfection for unmatched aroma and flavor.',
    paragraphs: [
        'Elevate your coffee experience with our hand-selected coffee beans. Carefully sourced from renowned regions, each batch is roasted to highlight its unique profile, ensuring a rich and satisfying cup.',
        'From single-origin selections to custom blends, we offer beans that suit every palate—perfect for espresso, pour-over, or cold brew lovers alike.'
    ],
    gallery: [
        images.service1Gallery1,
        images.service1Gallery2
    ],
    features: [
        'Single-Origin & Blended Options',
        'Freshly Roasted in Small Batches',
        'Rich Aroma & Complex Flavor Profiles',
        'Whole Bean or Ground Options',
        'Perfect for Home or Café Brewing'
    ],
    process: [
        'Select Origin or Blend Type',
        'Choose Roast Level (Light, Medium, Dark)',
        'Decide on Whole Bean or Ground',
        'Packaging & Freshness Seal',
        'Pickup or Delivery to Your Location'
    ],
    faqs: [
        {
            id: 1,
            heading: 'Where are your coffee beans sourced from?',
            content: 'We partner with top farms across Colombia, Ethiopia, Brazil, and more, ensuring quality and ethical sourcing.'
        },
        {
            id: 2,
            heading: 'Do you offer ground and whole bean options?',
            content: 'Yes, you can choose to receive your coffee as whole beans or ground to your preferred brew method.'
        },
        {
            id: 3,
            heading: 'How long do the beans stay fresh?',
            content: 'Our beans are roasted in small batches and sealed for freshness. For best flavor, consume within 4 weeks of opening.'
        },
        {
            id: 4,
            heading: 'Can I subscribe to regular deliveries?',
            content: 'Absolutely! We offer flexible subscription plans for regular coffee bean deliveries based on your preferences.'
        }
    ]
},
{
    id: 2,
    image: images.service2,
    title: 'Own Roasting',
    content: 'Experience the art of roasting with our in-house process that brings out the best in every bean—crafted fresh, daily.',
    paragraphs: [
        'Discover the difference of in-house roasting, where every batch is tailored to enhance flavor, aroma, and freshness. Our roasting experts carefully control time and temperature to develop bold, nuanced profiles.',
        'Whether you prefer a light roast or dark intensity, our custom roasting ensures every sip delivers a rich and memorable experience.'
    ],
    gallery: [
        images.service2Gallery1,
        images.service2Gallery2
    ],
    features: [
        'Fresh Daily Roasts',
        'Customizable Roast Profiles',
        'Light, Medium & Dark Options',
        'Roasted On-Site by Experts',
        'Ideal for Home Brewing or Cafés'
    ],
    process: [
        'Select Coffee Bean Type',
        'Determine Desired Roast Level',
        'Monitor Roast in Small Batches',
        'Cool & Seal for Freshness',
        'Ready for Brewing or Sale'
    ],
    faqs: [
        {
            id: 1,
            heading: 'What’s special about in-house roasting?',
            content: 'In-house roasting gives us full control over freshness and flavor, resulting in a richer, more aromatic coffee experience.'
        },
        {
            id: 2,
            heading: 'Can I choose my own roast level?',
            content: 'Yes, we offer customizable roast levels—light, medium, or dark—based on your taste preferences.'
        },
        {
            id: 3,
            heading: 'Do you roast beans daily?',
            content: 'Yes, we roast in small batches daily to ensure every bag is fresh and full of flavor.'
        },
        {
            id: 4,
            heading: 'Can I watch the roasting process?',
            content: 'Absolutely! We welcome guests to observe our roasting sessions and learn about the process behind each cup.'
        }
    ]
},
{
    id: 3,
    image: images.service3,
    title: 'High Quality',
    content: 'Premium-grade ingredients and expert craftsmanship come together to deliver consistently superior coffee and treats.',
    paragraphs: [
        'Quality is our signature. From bean to cup, every element is carefully selected to ensure the best taste, aroma, and presentation.',
        'We prioritize sourcing top-tier coffee beans, organic ingredients, and artisanal techniques to maintain a standard of excellence in every order.'
    ],
    gallery: [
        images.service3Gallery1,
        images.service3Gallery2
    ],
    features: [
        'Top-Tier Coffee Beans',
        'Organic & Fresh Ingredients',
        'Barista-Certified Brewing Techniques',
        'Strict Quality Control Measures',
        'Consistently Delicious Results'
    ],
    process: [
        'Source Premium Ingredients',
        'Follow Expert Brewing Methods',
        'Inspect for Quality & Taste',
        'Maintain Equipment & Hygiene',
        'Serve with Presentation Excellence'
    ],
    faqs: [
        {
            id: 1,
            heading: 'What makes your quality stand out?',
            content: 'We use only premium beans and ingredients, apply strict quality control, and follow expert preparation techniques.'
        },
        {
            id: 2,
            heading: 'Are your ingredients organic or locally sourced?',
            content: 'Yes, we strive to use organic and locally sourced ingredients whenever possible to ensure freshness and sustainability.'
        },
        {
            id: 3,
            heading: 'Do you train your staff for quality control?',
            content: 'All our staff are trained baristas and kitchen professionals who follow standardized protocols for quality and consistency.'
        },
        {
            id: 4,
            heading: 'Is there a difference in quality for dine-in and takeout?',
            content: 'Not at all—every item, whether for dine-in or takeaway, meets our same high standards of quality.'
        }
    ]
},
{
    id: 4,
    image: images.service4,
    title: 'Freshly Brewed',
    content: 'Experience the rich aroma and flavor of coffee that’s brewed fresh with every order, using expert techniques and quality beans.',
    paragraphs: [
        'Every cup we serve is freshly brewed to ensure maximum flavor and satisfaction. We grind beans on demand and use precise methods to craft the perfect cup.',
        'Whether it’s an espresso, cappuccino, or cold brew, our team ensures your coffee is always served at its freshest and finest.'
    ],
    gallery: [
        images.service4Gallery1,
        images.service4Gallery2
    ],
    features: [
        'Made-to-Order Brewing',
        'On-Demand Bean Grinding',
        'Specialty Brewing Techniques',
        'Temperature & Time Control',
        'Consistently Fresh Aroma & Flavor'
    ],
    process: [
        'Select Beans & Grind On Demand',
        'Choose Brewing Method (Espresso, Pour-Over, etc.)',
        'Monitor Water Temperature & Timing',
        'Brew & Pour with Care',
        'Serve Immediately for Freshness'
    ],
    faqs: [
        {
            id: 1,
            heading: 'Do you brew coffee fresh for each customer?',
            content: 'Yes, every cup is brewed fresh upon order to guarantee the best taste and experience.'
        },
        {
            id: 2,
            heading: 'What brewing methods do you offer?',
            content: 'We offer espresso, pour-over, French press, AeroPress, and cold brew options.'
        },
        {
            id: 3,
            heading: 'How do you ensure freshness in your brews?',
            content: 'We grind beans per order, use filtered water, and follow strict timing and temperature controls.'
        },
        {
            id: 4,
            heading: 'Can I customize how my coffee is brewed?',
            content: 'Absolutely! Let us know your preferred method or strength and we’ll brew it just how you like.'
        }
    ]
},
{
    id: 5,
    image: images.service5,
    title: 'Coffee Variety',
    content: 'Explore a diverse range of coffee flavors and styles, from bold espressos to creamy lattes, crafted to suit every preference.',
    paragraphs: [
        'Our menu offers a wide spectrum of coffee experiences, catering to all tastes—from intense dark roasts to light and fruity brews.',
        'Whether you love a classic Americano, a flavored latte, or a seasonal special, you’ll always find something new to enjoy.'
    ],
    gallery: [
        images.service5Gallery1,
        images.service5Gallery2
    ],
    features: [
        'Extensive Coffee Menu',
        'Single-Origin & House Blends',
        'Hot & Cold Brew Options',
        'Seasonal Specialties',
        'Custom Flavor Enhancements'
    ],
    process: [
        'Select Coffee Type (Espresso, Latte, etc.)',
        'Choose Beans or Blend',
        'Add Flavor or Milk Options',
        'Brew with Precision',
        'Serve Fresh with Custom Toppings'
    ],
    faqs: [
        {
            id: 1,
            heading: 'What types of coffee do you serve?',
            content: 'We offer espresso, latte, cappuccino, Americano, mocha, cold brew, and more.'
        },
        {
            id: 2,
            heading: 'Do you offer seasonal or limited-time coffees?',
            content: 'Yes! We regularly introduce seasonal blends and special flavor creations.'
        },
        {
            id: 3,
            heading: 'Can I customize my drink?',
            content: 'Absolutely. You can choose your preferred coffee base, milk type, sweetness, and flavors.'
        },
        {
            id: 4,
            heading: 'Do you have decaf options?',
            content: 'Yes, decaffeinated options are available for most of our drinks.'
        }
    ]
},
{
    id: 6,
    image: images.service6,
    title: 'Excellent Grinding',
    content: 'Precision-ground coffee beans for the freshest flavor and optimal extraction—tailored for every brew method.',
    paragraphs: [
        'Our expert grinding ensures each cup of coffee is brewed to perfection. Whether it’s for espresso, French press, or drip coffee, we grind beans to match your brewing style.',
        'Freshly ground on-site for every order, we preserve the aroma and flavor that make each cup rich and satisfying.'
    ],
    gallery: [
        images.service6Gallery1,
        images.service6Gallery2
    ],
    features: [
        'Fresh Daily Grinding',
        'Brew-Specific Grind Levels',
        'On-Demand Bean Preparation',
        'Enhanced Aroma Retention',
        'Quality-Controlled Consistency'
    ],
    process: [
        'Choose Coffee Beans or Blend',
        'Select Your Brewing Method',
        'Adjust Grind Size Accordingly',
        'Grind Fresh Per Order',
        'Serve or Package Immediately'
    ],
    faqs: [
        {
            id: 1,
            heading: 'Do you grind coffee on-site?',
            content: 'Yes, all our coffee is ground fresh on-site to ensure maximum flavor.'
        },
        {
            id: 2,
            heading: 'Can I choose the grind size?',
            content: 'Definitely. We adjust the grind depending on your preferred brewing method.'
        },
        {
            id: 3,
            heading: 'Do you sell pre-ground coffee?',
            content: 'Yes, you can request your favorite beans to be ground and packed for home use.'
        },
        {
            id: 4,
            heading: 'What brewing methods do you support?',
            content: 'We provide grinding for espresso, French press, drip coffee, pour-over, and more.'
        }
    ]
}

];

export default services;